export default {
    findSeries: {
        method: 'get',
        url: 'serie'
    }
}